import $api from "../http";
import { IAddon } from "../models/Addon";

class AddonServiceClass {
  async createAddon(model: Omit<IAddon, "id">) {
    return await $api.post<boolean>("api/addons/create", model);
  }

  async getAllAddons(searchValue: null | string) {
    return await $api.get<IAddon[]>(`api/addons/get-all?searchValue=${searchValue || ""}`);
  }

  async updateAddon(id: string, model: Omit<IAddon, "id">) {
    return await $api.put<boolean>(`api/addons/update/${id}`, model);
  }

  async deleteAddon(id: string) {
    return await $api.delete<boolean>(`api/addons/delete/${id}`);
  }
}

export const AddonService = new AddonServiceClass();
